export enum ColorScheme {
  DarkCyan = '#132626',
  DarkGreen = '#193232',
  White = '#ffffff',
  BrobizzGreen = '#00A050',
  LightGrey = '#efefef',
  Grey1 = '#E0E0E0',
  Grey2 = '#C0C0C0',
  // Grey3 = '#818181', Duplicate of Grey5, await designer
  Grey4 = '#969696',
  Grey5 = '#818181',
  Grey6 = '#747474',
  Grey7 = '#2d2d2d',
  TableGrey = 'F7F7F7',
  ErrorRed = '#FF004A',
  Yellow = '#FEFFC3',
  // Invoice status - Business: red badge #FAE2E2, green badge #CCF4E0. Private: red table #FAE2E280, green table #DEE9E4B3 (70%)
  OverdueBackground = '#FAE2E2',
  CreditBadgeBackground = '#CCF4E0',
  OutstandingBackground = '#FAE2E280',
  CreditBackground = '#DEE9E4B3'
}

export default ColorScheme;
